import React from 'react';
import useDebounceCallback from '../hooks/useDebounceCallback';

export function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows ? preGlobalFilteredRows.length : 0;
  const [value, setValue] = React.useState(globalFilter);

  // Debounce to avoid updating on every keystroke
  const onChange = useDebounceCallback((val) => {
    setGlobalFilter(val || undefined);
  }, 200);

  if (!preGlobalFilteredRows) {
    return <div className="p-2 text-gray-500">Loading data...</div>;
  }

  // A clear button to reset search quickly
  const handleClear = () => {
    setValue('');
    onChange('');
  };

  return (
    <>
      {/* Inline styles to disable the built-in clear icons */}
      <style>{`
        input[type="search"]::-webkit-search-cancel-button,
        input[type="search"]::-webkit-search-decoration,
        input[type="search"]::-webkit-search-results-button,
        input[type="search"]::-webkit-search-results-decoration {
          display: none;
        }
      `}</style>
      <div className="relative w-full">
        {/* Magnifying Glass Icon */}
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-5 w-5 text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
            />
          </svg>
        </div>

        {/* Actual Search Input */}
        <input
          autoComplete="off"
          type="search"
          id="lmiSearch"
          className="block w-full pl-10 pr-10 py-2 border border-gray-300 
            rounded-lg text-base leading-5 text-slate-900 
            focus:outline-none focus:ring-2 focus:ring-blue-500 
            focus:border-blue-500 transition duration-150"
          value={value || ''}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          placeholder={`Search among ${count.toLocaleString()} occupations...`}
        />

        {/* Custom Clear Button (X) if there's text */}
        {value && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute inset-y-0 right-2 flex items-center
              text-black hover:text-blue-700"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </>
  );
}